import { Flex } from '@acsbe/ui';

const AccessibilityStatement = (props: { licenseId: string }) => {
  return (
    <Flex stretch>
      <iframe
        src={`${import.meta.env.VITE_DASHBOARD_URL}/app/statement?license=${props.licenseId}`}
        title="Accessibility Statement"
        width="100%"
        height="100%"
        style={{ border: 'none', minHeight: '500px' }}
      ></iframe>
    </Flex>
  );
};
export { AccessibilityStatement };
